export default function Modal({ title, onClose, children, wide, testId }) {
  return (
    <div
      data-testid={testId || 'modal'}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '40px 16px',
        zIndex: 1000,
        overflowY: 'auto',
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          width: '100%',
          maxWidth: wide ? 760 : 520,
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,.3)',
        }}
        className="fade-up"
      >
        <div
          style={{
            background: '#0D1B3E',
            color: '#fff',
            padding: '16px 22px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontWeight: 800, fontSize: 16 }}>{title}</span>
          <button
            data-testid="modal-close-btn"
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,.15)',
              border: 'none',
              color: '#fff',
              borderRadius: 8,
              padding: '4px 12px',
              fontWeight: 700,
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ padding: '22px', maxHeight: '78vh', overflowY: 'auto' }}>{children}</div>
      </div>
    </div>
  );
}
